module.exports = function( $scope, $ ) {
	if ( ! kitbuilderFrontend.isEditMode() ) {
		return;
	}

	if ( $scope.hasClass( 'kitbuilder-widget-edit-disabled' ) ) {
		return;
	}

	$scope.find( '.kitbuilder-element' ).each( function() {
		kitbuilderFrontend.elementsHandler.runReadyTrigger( $( this ) );
	} );
};
